export default function isDragging(element, callback) {
    let isDragging = false;
    let startX, startY;

    function onMouseDown(e) {
        isDragging = false;
        startX = e.clientX;
        startY = e.clientY;
    }

    function onMouseMove(e) {
        if (Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5) {
            isDragging = true;
        }
    }

    function onMouseUp(e) {
        if (!isDragging) {
            callback(true); // Click
        } else {
            callback(false); // Drag
        }
    }

    function onTouchStart(e) {
        isDragging = false;
        const touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
    }

    function onTouchMove(e) {
        const touch = e.touches[0];
        if (Math.abs(touch.clientX - startX) > 5 || Math.abs(touch.clientY - startY) > 5) {
            isDragging = true;
        }
    }

    function onTouchEnd(e) {
        if (!isDragging) {
            callback(true); // Click
        } else {
            callback(false); // Drag
        }
    }

    // Add event listeners to the element
    element.addEventListener('mousedown', onMouseDown);
    element.addEventListener('mousemove', onMouseMove);
    element.addEventListener('mouseup', onMouseUp);

    element.addEventListener('touchstart', onTouchStart);
    element.addEventListener('touchmove', onTouchMove);
    element.addEventListener('touchend', onTouchEnd);
}